import React, { useState } from 'react';
import Button from '@99designs/frontend-components/components/Button/Button';
import ButtonGroup, {
    ButtonGroupItem,
} from '@99designs/frontend-components/components/ButtonGroup/ButtonGroup';
import { IconAdmin1 } from '@99designs/icons';

interface Props {
    debugMode: boolean;
}

function Debug({ debugMode }: Props) {
    const [showGrid, setShowGrid] = useState(false);
    const [highlightSections, setHighlightSections] = useState(false);

    const toggleHighlightSections = (attribute: string) => {
        if (window && window.document) {
            const body = window.document.querySelector('body');

            if (body) {
                body.toggleAttribute(attribute);
                setHighlightSections(!highlightSections);
            }
        }
    };

    if (debugMode) {
        return (
            <div className="debug">
                <div className="debug__controls">
                    <ButtonGroup variations={['joined']}>
                        <ButtonGroupItem>
                            <Button
                                onClick={() => setShowGrid(!showGrid)}
                                isActive={showGrid}
                                variations={['small', 'secondary', 'joined', 'first']}
                                icon={<IconAdmin1 />}
                                iconAlignment="left"
                            >
                                Grid
                            </Button>
                        </ButtonGroupItem>
                        <ButtonGroupItem>
                            <Button
                                onClick={() => toggleHighlightSections('data-debug-sections')}
                                isActive={highlightSections}
                                variations={['small', 'secondary', 'joined', 'last']}
                                icon={<IconAdmin1 />}
                                iconAlignment="left"
                            >
                                Sections
                            </Button>
                        </ButtonGroupItem>
                    </ButtonGroup>
                </div>

                {showGrid && (
                    <div className="debug__grid">
                        <div className="row">
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((col) => (
                                <div className="column large-1 normal-1 medium-1 small-1" key={col}>
                                    <div>
                                        <span>{col}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        );
    }

    return null;
}

export default Debug;
